module.exports = __webpack_public_path__ + "img/ico_borrar.dc01f446.svg";